import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import $ from "jquery";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import DetailsOrg from "../DetailsOrg";
import EditOrg from "../EditOrg";
import "./ListOrg.css";
import AddOrgEmail from "../../shared/AddOrgEmail";
import { Dropdown } from "primereact/dropdown";

const ListOrg = () => {
  const navigate = useNavigate();
  const {
    userRole,
    userToken,
    searchObj,
    orgObj,
    setOrgObj,
    sharedObject,
    SetSharedObject,
    setCustomerObj,
    userSession,
    setSearchObj,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    searchObj: state.searchObj,
    orgObj: state.orgObj,
    setOrgObj: state.setOrgObj,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    setCustomerObj: state.setCustomerObj,
    userSession: state.userSession,
    setSearchObj: state.setSearchObj,
  }));
  const [gridObj, setgridObj] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [deleteConfirm, SetDeleteConfirm] = useState(false);
  const [userOrgName, setUserOrgName] = useState("List");
  const [showGridFlag, SetShowGridFlag] = useState(
    userRole === "SES ADMINISTRATOR" ? false : true
  );
  const [orgDetails, SetOrgDetails] = useState("");
  const [nameSearch, SetNameSearch] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [custObj, SetCustObj] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState(null);
  const [keyFlag, SetKeyFlag] = useState(null);
  const [nrFlag, SetNrFlag] = useState(0);
  const [nrVal, SetNrVal] = useState(0);
  const [sortFlag, SetSortFlag] = useState(false);
  const [msg, SetMsg] = useState("");
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errOrgFlag, SeterrOrgFlag] = useState(false);
  const [currentOrg, SetCurrentOrg] = useState(null);
  const [custFlag, SetCustFlag] = useState(false);
  const [editObj, SetEditObj] = useState(false);
  const [showBackBtn, SetShowBackBtn] = useState(false);
  const [vendorId, SetVendorId] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [createUser, SetCreateUser] = useState(false);
  const toggleApplications = (el) => {
    let _expandedKeys = { ...expandedKeys };
    if (_expandedKeys[el]) delete _expandedKeys[el];
    else _expandedKeys[el] = true;
    setExpandedKeys(_expandedKeys);
  };
  const [refreshObj, SetRefreshObj] = useState(Date.now());
  const deleteOrg = async () => {
    SetErrCreateMsg(false);
    //$("#DeleteOrg").modal("hide");
    let id = sharedObject.orgActionObj.id;
    SetProcessing(true);
    let call = "/organization/DeleteOrg?orgId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetDeleteConfirm(true);
      CustomerIdSet(vendorId + "-Name");
      SetProcessing(false);
      $("#DeleteOrg").modal("show");
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
      $("#DeleteOrg").modal("show");
    }
  };
  const getOrganizationById = async (id, flag) => {
    SetProcessing(true);

    let call = "/organization/getOrganizationById?orgId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res.data.data.organization;
      det.tlsCertExists = res.data.data.tlsCertExists;
      det.parentList = res.data.data.parentList;
      custObj.map((elx) => {
        if (elx.id === parseInt(det.vendorId))
          SetSharedObject("CustomerPermissionsObj", elx);
      });
      SetOrgDetails(det);
      SetSharedObject("orgActionObj", det);
      SetSharedObject("CSRUploadFlag", det.tlsCertExists);
      SetSharedObject("xdrSettiingObj", det.xdrConfig);
      SetSharedObject("specialties", det.specialties);
      $("#detailsOrgModal").modal("show");
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetMsg(`<div>${res.data.message}</div>`);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
  };
  const orgSubFunc = async (obj) => {
    SetProcessing(true);
    let model = { ParentOrganizationId: obj.id };
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, model, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    let thirdChildren = [];
    let fourChildreen = [];
    if (res.status === "SUCCESS") {
      let arr = res.data.data;
      let fullObj = JSON.parse($("#objData").val());
      const temp = [];
      let key = obj.key;
      let dpth = obj.key.split("-");
      let child = await getOrgs(arr, key, false);
      for (const row of fullObj) {
        let rw = await getOrgs([row.data], false);
        rw = rw[0];
        if (dpth.length === 1 && row.key === key) {
          rw.children = child;
        }
        if (row?.children?.length > 0) {
          rw.children = row.children;
        }
        if (rw?.children?.length > 0) {
          let nr = 0;
          for (const el of rw.children) {
            let r = await getOrgs([el.data], rw.key, nr++);
            let rs = r[0];
            let eel = rs;
            if (dpth.length === 2 && el.key === key) {
              el.children = child;
              eel.children = child;
            }
            if (el?.children?.length > 0) {
              eel.children = el.children;
            }
            if (eel?.children?.length > 0) {
              let nrs = 0;
              for (const elx of eel.children) {
                let x = await getOrgs([elx.data], eel.key, nrs++);
                let elxx = x[0];
                if (dpth.length === 3 && elx.key === key) {
                  elx.children = child;
                  elxx.children = child;
                }
                if (elx?.children?.length > 0) {
                  elxx.children = elx.children;
                }
                if (elxx?.children?.length > 0) {
                  let nrss = 0;
                  for (const four of elxx.children) {
                    let xx = await getOrgs([four.data], elxx.key, nrss++);
                    let fourth = xx[0];
                    if (dpth.length === 4 && four.key === key) {
                      four.children = child;
                      fourth.children = child;
                    }
                    if (four?.children?.length > 0) {
                      fourth.children = four.children;
                    }
                    if (fourth?.children?.length > 0) {
                      let f = 0;
                      for (const five of fourth.children) {
                        let xs = await getOrgs([five.data], fourth.key, f++);
                        let fivth = xs[0];
                        if (dpth.length === 5 && five.key === key) {
                          five.children = child;
                          fivth.children = child;
                        }
                        if (five?.children?.length > 0) {
                          fivth.children = five.children;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        temp.push(rw);
      }
      let str = JSON.stringify(temp);
      await $("#objData").val(str);
      await setgridObj(temp);
      await setOrgObj(temp);
      SetKeyFlag(key);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const getOrgs = async (funcObj, id, nr) => {
    SetProcessing(true);
    let tempObj = [];
    let opt =
      userSession?.CreateUserFlag || userRole === "SES ADMINISTRATOR"
        ? ["Add User", "Add Org", "Add Org Email", "Delete"]
        : ["Add Org", "Add Org Email", "Delete"];
    let k = -1;
    for (const row of funcObj) {
      row.CustomerId = vendorId;
      k++;
      if (nr) k = nr;
      let childKey = id ? id + "-" + k : "" + row.id + "";
      let sub = (
        <Link
          underline="none"
          className="font-weight-bold"
          onClick={(el) => {
            orgSubFunc(row, funcObj);
          }}
        >
          {"View"}
        </Link>
      );
      row.showChilds = row.hasChildren ? sub : "No";
      row.key = childKey;
      let topOrg = row.isRootOrganization ? (
        <i
          className="bi bi-star-fill sp-margin12"
          title="Top Level Org"
          alt="Top Level Org"
        ></i>
      ) : null;
      let cs = (
        <Link
          underline="none"
          className="font-weight-bold"
          onClick={(el) => {
            orgNameFunc(row);
          }}
        >
          {row.name}
          {topOrg}
        </Link>
      );
      row.EditCourse = cs;
      let select = (
        <select
          onChange={(el) => {
            userActions(row, el.target.value);
          }}
          id={`UserActions${row.id}`}
          value={nrVal}
          className="form-control form-control-sm p-0 ht-4"
        >
          <option value="">Select</option>
          {opt.map((el, i) => {
            return (
              <option key={i} value={el}>
                {el}
              </option>
            );
          })}
        </select>
      );
      row.dCreated = new Date(row.dateCreated);
      row.Show = true;
      row.Actions = select;
      let o = {
        key: childKey,
        data: row,
      };
      tempObj.push(o);
    }
    SetProcessing(false);
    return tempObj;
  };
  useEffect(() => {
    SetShowBackBtn(false);
    const getOrgsObj = async (obj) => {
      //setOrgObj(obj);
      let ob = await getOrgs(obj, false);
      let str = JSON.stringify(ob);
      $("#objData").val(str);
      await setgridObj(ob);
      SetShowGridFlag(true);
    };
    if (Object.keys(searchObj).length > 0) {
      if (searchObj.ShowParent === "ShowParent") {
        orgEdit(searchObj, "orgSearch");
      } else {
        SetCustFlag(false);
        getOrgsObj(searchObj);
      }
    } else {
      if (userRole !== "SES ADMINISTRATOR") {
        SetVendorId(userSession.vendor_id);
        let o = { ...userSession, id: userSession.vendor_id };
        SetSharedObject("CustomerPermissionsObj", o);
        CustomerIdSet(userSession.vendor_id + "-Name");
      } else {
        SetCustObj(sharedObject.vendorsObj);
        let obj = sharedObject.UserIdEmail;
        if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
          if (obj.Flag !== "customer") {
            let o = { OrganizationName: obj.Name };
            OrgSearchEngine(o, obj.CustomerId);
            SetCustFlag("org");
          } else {
            SetShowBackBtn(true);
            let o = { VendorId: obj.id };
            OrgSearchEngine(o, obj.id);
            SetCustFlag("customer");
          }

          setUserOrgName(obj.Name);
          SetShowGridFlag(true);
        }
      }
    }
    SetSharedObject("AdvOrgSearchFlag", false);
  }, [searchObj]);
  useEffect(() => {
    //SetEditObj(false);
    toggleApplications(keyFlag);
    // if (nrFlag > 0) {
    //   SetNrFlag("");
    // }
    // return () => {
    //   setSearchObj({});
    // };
  }, [keyFlag]);
  const OrgSearchEngine = async (obj, custId) => {
    SetProcessing(true);
    SetVendorId(custId);
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      SetShowGridFlag(true);
      const ob = await getOrgs(dt, false, custId);
      let str = JSON.stringify(ob);
      $("#objData").val(str);
      await setgridObj(ob);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR" || res.status === "ECONNABORTED") {
      $(".modal").modal("hide");
      SetProcessing(false);
    }
  };
  const orgNameFunc = async (row) => {
    SetCurrentOrg(row);
    setSelectedProductId(row.key);
    let nm = "";
    sharedObject.vendorsObj.map((elx) => {
      if (elx.id === parseInt(row.vendorId)) {
        nm = elx.name;
      }
    });
    SetCustomerName(nm);
    await getOrganizationById(row.id);
  };
  const getOrganizations = async (vl, name) => {
    SetProcessing(true);
    SeterrOrgFlag(false);
    let vId = !vl ? 0 : vl;
    let call = "/organization/GetOrgsByUser?vendorId=" + vId + "&Name=" + name;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      const ob = await getOrgs(dt, false);
      let str = JSON.stringify(ob);
      $("#objData").val(str);
      await setgridObj(ob);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SeterrOrgFlag(true);
      SetProcessing(false);
    }
  };

  const orgEdit = async (val, flag, subOrgFlag) => {
    if (flag === "orgSearch") {
      if (val.ShowParent === "ShowParent") {
        await OrgSearchEngine(val, false);
      }
      await getOrganizationById(val.id);
    } else if (subOrgFlag) {
      SetShowBackBtn(true);
      setUserOrgName(val.organizationName);
      SetProcessing(true);
      let model = { ParentOrganizationId: currentOrg.id };
      let call = "/organization/OrgSearchEngine";
      const res = await CallAPI(call, model, "post", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let arr = res.data.data;
        let ob = await getOrgs(arr, false);
        let str = JSON.stringify(ob);
        $("#objData").val(str);
        await setgridObj(ob);
        SetShowGridFlag(true);
        SetProcessing(false);
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
    } else {
      SetEditObj(val);
      $("#editOrgModal").modal("show");
    }
  };
  const showParent = (flag) => {
    if (flag) {
      if (sharedObject.UserIdEmail.Navigate === "email") {
        navigate("/emails");
      } else if (sharedObject.UserIdEmail.Navigate === "customer") {
        navigate("/customers");
      }
    } else {
      setUserOrgName("");
      SetShowBackBtn(false);
      getOrganizations(vendorId, "");
    }
  };
  const userActions = (row, type) => {
    let o = {
      ...row,
      Name: row.name,
      Type: "sub",
      OrgType: "org",
      VendorId: row.vendorId,
    };

    setCustomerObj(o);
    SetSharedObject("orgActionObj", o);
    SetSharedObject("orgActionObjForUser", o);

    if (type === "Add User") {
      navigate("/user-registration");
    } else if (type === "Add Org") {
      navigate("/organization-registration");
    } else if (type === "Add Org Email") {
      $("#AddOrgEmailModal").modal("show");
      SetNrFlag(row.id);
    } else if (type === "Delete") {
      SetNrFlag(row.id);
      SetDeleteConfirm(false);
      $("#DeleteOrg").modal("show");
      SetErrCreateMsg(false);
    }
  };
  const [CustomerName, SetCustomerName] = useState("");
  const CustomerIdSet = async (val) => {
    setUserOrgName("List");

    if (val === "") {
      return;
    }
    SetSharedObject("CustomerPermissionsObj", val);
    let vl = val.split("-");
    SetCustomerName(vl[1]);
    SetVendorId(vl[0]);
    let o = { VendorId: vl[0] };
    custObj.map((elx) => {
      if (elx.id === parseInt(vl[0]))
        SetSharedObject("CustomerPermissionsObj", elx);
    });
    OrgSearchEngine(o, vl[0]);
    SetCustFlag(false);
    SetShowGridFlag(true);
  };

  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchOrg();
    }
  };
  const SearchOrg = () => {
    SetCustFlag(false);
    let o = { OrganizationName: nameSearch };
    OrgSearchEngine(o, false);
    SetShowGridFlag(true);
  };
  const handleEdit = (el) => {
    let address = el?.Addresses[0];
    gridObj.map((e) => {
      if (el.Id === e.data.id) {
        e.data.zip = address.PostalCode;
        e.data.city = address.City;
        e.data.state = address.State;
      }
    });
    getOrganizationById(currentOrg.id);
  };
  const OpenAdvSearch = async () => {
    await SetSharedObject("AdvOrgSearchFlag", true);
    $("#advOrgSearchModal").modal("show");
  };
  const nameBodyTemplate = (product) => {
    SetSortFlag(!sortFlag);
    if (sortFlag)
      gridObj.sort((a, b) => a.data.name.localeCompare(b.data.name));
    else gridObj.sort((a, b) => b.data.name.localeCompare(a.data.name));
  };
  const dateCreatedDate = (dt) => {
    return dt.data.dateCreated
      ? new Date(dt.data.dateCreated).toLocaleString()
      : null;
  };
  return (
    <div className="ListOrg">
      <div className="HeaderOrgTools">
        {errOrgFlag ? (
          <div className={`alert alert-danger sp-margin5 sp-margin12`}>
            System encountered an error. Please try again. If the problem
            persists, please contact your administrator.
          </div>
        ) : null}
        <div className="HeaderTools">
          <header className="ht-6">
            {(showBackBtn || custFlag) &&
            sharedObject.UserIdEmail.Navigate !== "org" ? (
              <div className="spacer-inline btnback-container-1">
                <a
                  href="javascript:void(0);"
                  onClick={(el) => showParent(custFlag)}
                >
                  <i className="bi bi-arrow-left-square-fill"></i>
                </a>
              </div>
            ) : null}

            <div className="title-label4">
              {custFlag === "customer" ? `Customer: ${userOrgName}` : "List"}
            </div>

            <div className="mid-header-bar">
              {/*Org and Customer Dropdown*/}
              <div className="OrgDropdown spacer-inline">
                <aside>
                  {/*Customer Dropdown List SES Admins only*/}
                  {userRole !== "SES ADMINISTRATOR" ? null : (
                    <Dropdown
                      value={selectedCustomer}
                      onChange={(e) => {
                        setSelectedCustomer(e.value);
                        CustomerIdSet(e.value?.id + "-" + e.value?.name);
                      }}
                      options={custObj}
                      optionLabel="name"
                      placeholder="Customer"
                      filter
                      className="form-control w-md2 spacer-margin5"
                    />
                  )}
                </aside>
              </div>

              {/*Search by name*/}
              <div className="spacer-inline spacer-margin5">
                <div className="input-group">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search by Name"
                    aria-label="Enter Organization"
                    aria-describedby="Search Orgs by Name"
                    value={nameSearch}
                    onChange={(el) => SetNameSearch(el.target.value)}
                    onKeyPress={SearchWithEnter}
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-secondary"
                      id="basic-addon2"
                      onClick={SearchOrg}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                  </div>
                </div>
              </div>

              {/*Advanced Search*/}
              <div className="spacer-inline">
                <button
                  className="btn btn-primary"
                  onClick={(el) => OpenAdvSearch()}
                >
                  {" "}
                  Adv Search{" "}
                </button>
              </div>
            </div>
          </header>
        </div>
      </div>

      {showGridFlag ? (
        <section className="grid-layout">
          <TreeTable
            value={gridObj}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 25, 50]}
            tableStyle={{ minWidth: "50rem" }}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            selectionMode="single"
            selectionKeys={selectedProductId}
            columnResizeMode="expand"
            resizableColumns
            dataKey="id"
            metaKeySelection={false}
            expandedKeys={expandedKeys}
            onToggle={(e) => setExpandedKeys(e.value)}
            sortField="dCreated"
            sortOrder={-1}
          >
            <Column
              field="EditCourse"
              header="Org Name"
              expander
              sortable
              sortField={(e) => nameBodyTemplate(e)}
            ></Column>
            <Column
              field="showChilds"
              header="Sub Orgs"
              className="w-md1"
              sortable
            ></Column>
            <Column
              field="organizationType"
              header="Type"
              className="w-md6"
              sortable
            ></Column>
            <Column
              field="city"
              header="City"
              className="w-md2"
              sortable
            ></Column>
            <Column
              field="state"
              header="State"
              className="w-md3"
              sortable
            ></Column>
            <Column
              field="zip"
              header="Zip"
              className="w-md3"
              sortable
            ></Column>
            <Column
              field="dCreated"
              header="Date Created"
              className="w-md8"
              body={dateCreatedDate}
              sortable
            ></Column>
            <Column field="Actions" header="Actions" className="w-md2"></Column>
          </TreeTable>

          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <i className="bi bi-star-fill"></i> Top Level Organization
            </div>
          </div>
        </section>
      ) : (
        <section className="empty-grid">
          There are currently no results.
        </section>
      )}
      <DetailsOrg
        orgDetails={orgDetails}
        orgEdit={orgEdit}
        customerName={CustomerName}
        CloseDetailOrg={(el) => {
          $("#detailsOrgModal").modal("hide");
        }}
      />

      <EditOrg
        editObj={editObj}
        vendorId={vendorId}
        closeEdit={(el) => handleEdit(el)}
      />

      <form hidden type="hidden">
        <input name="objData" id="objData" />
      </form>
      <AddOrgEmail />
      <div
        className="modal fade"
        id="DeleteOrg"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Confirmation"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Delete Confirmation</div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="descript2-container">
                {deleteConfirm ? (
                  <>
                    <div className="bi-success-check">
                      <i
                        className="bi bi-check2-circle"
                        alt="Success Checkmark"
                      ></i>
                    </div>
                    <div className="message-wrapper">
                      {`${sharedObject.orgActionObj.name} deleted successfully!`}
                    </div>
                  </>
                ) : (
                  `Please be advised that this action cannot be reversed and anything associated with this organization will not be accessible.`
                )}
              </p>
              <p className="ft-wt blk-clr ctr">
                {deleteConfirm
                  ? null
                  : `Are you sure you want to delete ${sharedObject?.orgActionObj?.name}?`}
              </p>
              {errCreateMsg ? (
                <div className={`alert alert-danger`}>
                  <div dangerouslySetInnerHTML={{ __html: msg }} />
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              {deleteConfirm ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(el) => deleteOrg()}
                >
                  Confirm
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {deleteConfirm ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {processing ? <div className="loading"></div> : null}
    </div>
  );
};

export default ListOrg;
